import { createRootRoute, Outlet } from '@tanstack/react-router';

// Root layout for the TanStack Router tree. Phase 1 intentionally has no
// sidebar, header, or bottom nav (see ux-guidelines.md "Navigation"); the
// authenticated welcome stub and the login screen are full-viewport on
// their own. The root just hosts the route Outlet and a shared <main>
// container so each child route can stay focused on its content.
export const Route = createRootRoute({
  component: RootLayout,
});

function RootLayout(): React.ReactElement {
  return (
    <main className="relative min-h-screen bg-paper text-ink">
      <div
        aria-hidden="true"
        className="pointer-events-none absolute inset-0 -z-10 bg-[radial-gradient(circle_at_15%_-10%,rgba(176,119,43,0.10),transparent_55%),radial-gradient(circle_at_95%_0%,rgba(92,122,83,0.07),transparent_50%)]"
      />
      <Outlet />
    </main>
  );
}
